const defaultState = {
  users: [],
  loading: false,
  error: false,
  errorMessage: null,
};

export const actionTypes = {
  getFirmUsers: 'GET_FIRM_USERS',
  catchError: 'CATCH_ERROR',
};

export const firmUsersReducer = (state = defaultState, action) => {
  switch (action.type) {
    case actionTypes.getFirmUsers: {
      const {users} = action.payload;
      return {
        ...state,
        users,
        loading: false,
        error: false,
        errorMessage: null
      }
    }
    case actionTypes.catchError: {
      const error = `FIRM USERS OPTIONS: ${action.payload.error}`;
      return {...state, error};
    }
    default:
      return state;
  }
};


export const actions = {
  getFirmUsers: (data) => ({
    type: actionTypes.getFirmUsers,
    payload: data
  }),
  catchError: (error) => ({
    type: actionTypes.catchError,
    payload: error
  }),
};
